import { cn } from "@/utils"
import * as React from "react"

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: "default" | "outline"
  size?: "default" | "sm"
}

export function Badge({
  className,
  variant = "default",
  size = "default",
  ...props
}: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full font-medium",
        {
          "bg-primary text-primary-foreground": variant === "default",
          "border": variant === "outline",
          "px-2.5 py-0.5 text-xs": size === "default",
          "px-2 py-0.5 text-xs": size === "sm",
        },
        className
      )}
      {...props}
    />
  )
} 